import { IAxiosError } from '@shared/types/AxiosError';
import { useQuery } from '@tanstack/react-query';

import { getAllPlans, IPlanPayload } from '../services';

export function useGetAllPlans() {
  const { data, isLoading, isFetching, error, ...query } = useQuery(
    ['getAllPlans'],
    () => getAllPlans(),
  );

  return {
    // plans: mock,
    data: data?.data || ([] as IPlanPayload),
    isFindingPlans: isLoading || isFetching,
    errorFindingPlans: error as IAxiosError,
    ...query,
  };
}
export const QUERY_KEY_GET_ALL_PLANS = ['getAllPlans'];
